import { Directive, ElementRef, inject, Input, OnInit } from '@angular/core';

/**
 * @deprecated Inert since Storyblok was removed (INEXP-2504). Do not add new
 * usages; remove the remaining ones when convenient.
 *
 * It stamped `data-blok-c` / `data-blok-uid` onto an element so Storyblok's
 * visual editor could map the rendered DOM back to the block that produced it.
 * Two things now make that impossible:
 *
 *  - The only input it can receive is a component's `_editable`, which was
 *    populated by `ndc-dynamic` spreading story content. Nothing produces that
 *    field any more — the layout renders from `layout.constants` and offering
 *    and knowledge blocks come from `mulesoft-offering.mapper`, neither of which
 *    emits `_editable`. Verified: no `_editable:` assignment and no
 *    `[_editable]` binding exists anywhere in `src/`.
 *  - The attributes are only meaningful to Storyblok's bridge script, which was
 *    dropped from `index.html`.
 *
 * So every instance takes the early return below. It is left in place rather
 * than deleted because unpicking it touches a dozen templates for no functional
 * gain; that sweep can happen on its own.
 */
@Directive({
  selector: '[appStoryblok]',
})
export class StoryblokDirective implements OnInit {
  private readonly _el = inject(ElementRef);

  @Input() appStoryblok = '';

  ngOnInit() {
    if (typeof this.appStoryblok !== 'string' || !this.appStoryblok.trim()) {
      return;
    }

    let options = JSON.parse(
      this.appStoryblok.replace('<!--#storyblok#', '').replace('-->', '')
    );

    this._el.nativeElement.setAttribute('data-blok-c', JSON.stringify(options));
    this._el.nativeElement.setAttribute(
      'data-blok-uid',
      options.id + '-' + options.uid
    );
  }
}
